<template>
  <shit-shell title="Personalize">
    <div class="px-6 text-right">
      <router-link class="text-xs uppercase mr-2" to="collect">Return to GYST</router-link>
    </div>
    <shit-todo :shit="shit"></shit-todo>
    <div class="h-1 bg-gray-100"></diV>
    <div class="hidden text-xs text-sm text-base text-lg text-xl text-2xl"></div>
    <div class="grid cols-1 px-6 py-2">
      <span class="text-sm">Text Size</span>
      <div class="mx-auto mt-4 flex items-center">
        <span class="text-xs pr-1">Text</span>
        <input class="" type="range" min="0" :max="sizes.length - 1" v-model="selectedSize">
        <span class="text-xl pl-1">Text</span>
      </div>
    </div>
    <div class="h-1 bg-gray-100"></diV>
    <label class="block px-6 py-2">
      <span class="text-sm">Todo View</span>
      <select class="form-select mt-1 block w-full" v-model="view">
        <option v-for="view in views" :key="view">{{ view }}</option>
      </select>
    </label>
  </shit-shell>
</template>

<script>
import ShitShell from '../components/ShitShell'
import ShitTodo from '../components/ShitTodo'
import { textSizes } from '../constants/shit-text-size'
import { viewTypes } from '../constants/shit-view-types'
import { addDays } from 'date-fns'

export default {
  components: {
    ShitShell,
    ShitTodo
  },
  data () {
    return {
      sizes: Object.values(textSizes),
      views: Object.values(viewTypes),
      shit: {
        description: 'Get this shit done tomorrow *daily for a #project with +mention at @context /schedule *weekdays',
        projects: ['project'],
        contexts: ['contexts'],
        mentions: ['mention'],
        action: 'schedule',
        scheduledAt: {
          start: addDays(new Date(), 1),
          repeat: 'weekdays'
        }
      }
    }
  },
  computed: {
    view: {
      get () {
        return this.$store.state.filters.view
      },
      set (value) {
        this.$store.commit('filters/setView', value)
      }
    },
    selectedSize: {
      get () {
        return Object.values(textSizes)
          .indexOf(this.$store.state.settings.textSize)
      },
      set (value) {
        this.$store.commit('settings/setTextSize', this.sizes[value])
      }
    }
  }
}
</script>
